import Swiper from "swiper";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "next", "prev", "pagination"];

  connect() {
    this.initSwiper();
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  initSwiper() {
    // Only initialize Swiper on mobile (< 768px)
    if (window.innerWidth < 768) {
      this.swiper = new Swiper(this.containerTarget, {
        // Slides per view configuration for mobile only
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,

        // Navigation arrows
        navigation: {
          nextEl: this.nextTarget,
          prevEl: this.prevTarget,
        },

        // Pagination dots
        pagination: {
          el: this.paginationTarget,
          clickable: true,
          dynamicBullets: false,
        },

        // Loop mode
        loop: false,

        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        // Touch settings
        touchEventsTarget: 'container',
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,

        // Smooth transitions
        speed: 600,
        effect: 'slide',

        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Specialista precedente',
          nextSlideMessage: 'Specialista successivo',
          firstSlideMessage: 'Questo è il primo specialista',
          lastSlideMessage: 'Questo è l\'ultimo specialista',
          paginationBulletMessage: 'Vai allo specialista {{index}}',
        },
      });
    }
  }

  handleResize() {
    if (window.innerWidth >= 768 && this.swiper) {
      // Destroy swiper on tablet and desktop
      this.swiper.destroy(true, true);
      this.swiper = null;
    } else if (window.innerWidth < 768 && !this.swiper) {
      // Reinitialize swiper on mobile
      this.initSwiper();
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResize);
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
